import { render, staticRenderFns } from "./ComponentPreview.vue?vue&type=template&id=63cce329&"
import script from "./ComponentPreview.vue?vue&type=script&lang=js&"
export * from "./ComponentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports